import axios from 'axios'
import qs from 'qs'

import store from '@/store'
import { RedemptionObject, TicketObject, QrCodeObject, Pagination } from '@/store/modules/redemption'
export async function getMyTickets(query: { expired: string; redeemed: string; page: number, limit: number }): Promise<{ tickets: RedemptionObject[], pagination: Pagination }> {
  const response = await axios.get(`/shopify/orders/groups?${qs.stringify(query)}`, {
    headers: {
      'x-ticket-token': store.getters.getToken,
    },
  })

  return {
    tickets: response.data.orderList,
    pagination: {
      first: response.data.first,
      last: response.data.last,
      size: response.data.size,
      currentPage: response.data.currentPage,
      currentPageOfElements: response.data.currentPageOfElements,
      totalPages: response.data.totalPages,
      totalElements: response.data.totalElements,
    }
  }
}

export async function getRedemptionGroup(id: string, query: { expired: boolean; redeemed: boolean }): Promise<TicketObject[]> {
  const response = await axios.get(`/shopify/orders/${id}/group?${qs.stringify(query)}`, {
    headers: {
      'x-ticket-token': store.getters.getToken,
    },
  })

  // TODO: remove this map when variants is fixed
  return response.data.products.map((product: TicketObject) => ({
    ...product,
    variants: product.variant.split(' / '),
  }))
}

export async function generateQrCode(orderId: string, bookingId: string, itemIds: string[]): Promise<QrCodeObject[]> {
  const response = await axios.post(
    '/shopify/orders/generate-qrcode-v2',
    { itemIds, orderId, bookingId },
    {
      headers: {
        'x-ticket-token': store.getters.getToken,
      },
    }
    )

    return response.data
}

export async function redeemGroup(
  groupId: string,
  itemIds: string[]
): Promise<boolean> {
  const response = await axios.put(
    `/shopify/orders/${groupId}/redeem`,
    { itemIds },
    {
      headers: {
        'x-ticket-token': store.getters.getToken,
      },
    }
  )

  return response.data.success
}

//get notification
export async function getRedemptionNotification(): Promise<TicketObject[]> {
  const response = await axios.get('/shopify/orders/check-status', {
    headers: {
      'x-ticket-token': store.getters.getToken,
    },
  })

  return response.data.products
}
